<script>
   let tabSet;
   let controlObj = {
      activeTab: null,
      tabLabels: [],
      setActiveTab: (lb) => controlObj.activeTab = lb,
      registerTab: (tabLabel, tabElem) => {
         //console.log(`Attempting register ${tabLabel}`);
         //console.log(tabElem);
         if(tabElem && !controlObj.tabLabels.includes(tabLabel)) {
            controlObj.tabLabels.push(tabLabel);
            tabSet.appendChild(tabElem);

            if(!controlObj.activeTab) {
               controlObj.activeTab = tabLabel;
            }

            //console.log(`Successful registration of ${tabLabel}`);
         }
      },
      discardTab: (tabLabel) => {
         //console.log(`Discarding ${tabLabel}`);
         //console.log(tabElem);
         if(tabSet && controlObj.tabLabels.includes(tabLabel)) {
            const rIdx = controlObj.tabLabels.indexOf(tabLabel);
            controlObj.tabLabels.splice(rIdx, 1);
            //tabSet.removeChild(tabElem);

            if(controlObj.activeTab === tabLabel) {
               if(controlObj.tabLabels.length > 0) {
                  const nIdx = rIdx < controlObj.tabLabels.length? rIdx: rIdx-1;
                  controlObj.activeTab = controlObj.tabLabels[nIdx];
               }
               else {
                  controlObj.activeTab = null;
               }
            }

            //console.log(`Successful discard of ${tabLabel}`);
         }
      }
   };
</script>

<ul bind:this={tabSet}></ul>
<slot tabControl={controlObj} />

<style>
    ul {
        display: flex;
        flex-wrap: wrap;

        padding-left: 0.5rem;
        margin-bottom: 0;
        list-style: none;
        width: calc(100% - 1rem)
    }
</style>